import { classNames, React } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { Text } from '@digsup/components-text';
import { styles } from './FeaturesItem.scss';

const cx = classNames.bind(styles);

export const FeaturesItem = ({ title, icon, description, media, ...props }) => {
  const classes = cx('l-homepage-features-item');

  return (
    <div className={classes} {...props}>
      <div className="l-homepage-features-item__content">
        <div className="u-margin-bottom-large">{icon}</div>
        <Text
          size={{ xsmall: 'xl', medium: 'lg' }}
          fontFamily="serif"
          fontWeight="semibold"
          marginBottom="small">
          {title}
        </Text>
        <p className="l-homepage-features-item__description">{description}</p>
      </div>
      <div className="l-homepage-features-item__media">{media}</div>
    </div>
  );
};

FeaturesItem.propTypes = {
  icon: PropTypes.any,
  title: PropTypes.string,
  description: PropTypes.any,
  media: PropTypes.any,
};
